{
  "nav": {
    "home": "Knowledge Dashboard",
    "silos": "Silos",
    "skills": "Skills",
    "arena": "Arena",
    "aiPowered": "AI-Powered",
    "knowledgeFlows": "Knowledge flows intelligently across your organization.",
    "askTheKnowledgeBase": "Ask the knowledge base",
    "ask": "Ask",
    "help": "Help",
    "logout": "Logout",
    "signIn": "Sign In",
    "openProfileInMe": "Your profile in JoyIA Me"
  },
  "common": {
    "loading": "Thinking…",
    "error": "Error",
    "save": "Save",
    "saving": "Saving...",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "hide": "Hide",
    "create": "Create",
    "search": "Search",
    "filter": "Filtered by source:",
    "refresh": "Last updated",
    "close": "Open navigation",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "submit": "Submit",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "all": "All",
    "none": "None",
    "select": "Select",
    "viewAll": "View All",
    "remove": "Remove filter",
    "add": "Add",
    "new": "New",
    "success": "Silo created",
    "warning": "Warning",
    "info": "Info",
    "noResults": "No results found",
    "noData": "Manage your knowledge silos and search across all content",
    "clear": "Clear",
    "sync": "Sync",
    "item": "item",
    "items": "items",
    "copied": "Copied!"
  },
  "silos": {
    "title": "Silos",
    "description": "Knowledge silos and document collections",
    "createNew": "Create New Silo",
    "editSilo": "Edit Silo",
    "deleteSilo": "Delete Silo",
    "siloSettings": "Silo Settings",
    "knowledge": "Knowledge",
    "project": "Project",
    "timeline": "Timeline",
    "sync": "Active Syncs",
    "syncHistory": "Sync History",
    "connectors": "Connectors",
    "statusLabel": "Status",
    "idle": "Idle",
    "running": "Running",
    "pending": "Pending",
    "error": "Error",
    "newSilo": "New Silo",
    "createSilo": "Create Silo",
    "myKnowledgeBase": "My Knowledge Base",
    "sortByName": "Name (A–Z)",
    "sortByCreated": "Last created",
    "heading": "Knowledge Silos",
    "unitCountSingular": "{{n}} silo",
    "unitCountPlural": "{{n}} silos",
    "itemCountSingular": "{{n}} item",
    "itemCountPlural": "{{n}} items",
    "memberCountSingular": "{{n}} member",
    "memberCountPlural": "{{n}} members",
    "searchPlaceholder": "Search silos...",
    "noMatches": "No silos match “{{search}}”",
    "emptyTitle": "No knowledge silos yet",
    "emptyBody": "Create your first silo to start building your knowledge base"
  },
  "skills": {
    "title": "Skills",
    "description": "Skills and capabilities",
    "createNew": "Create New Skill",
    "editSkill": "Edit Skill",
    "deleteSkill": "Delete Skill",
    "arena": "Arena",
    "skillDetails": "Skill Details",
    "knowledge": "Knowledge",
    "project": "Project",
    "mine": "My Skills",
    "unitCountSingular": "{{n}} skill",
    "unitCountPlural": "{{n}} skills",
    "newSkill": "New Skill",
    "searchPlaceholder": "Search skills…",
    "allCategories": "All categories",
    "emptyTitle": "No skills found",
    "emptyBody": "Create your first skill or import one from GitHub or skills.sh",
    "sharedWithTribes": "Shared with tribes",
    "thisTribeHint": "Skills shared with this tribe. Open a skill for installation instructions.",
    "sharedTribesHint": "Skills shared with tribes you belong to. Open a skill for installation instructions.",
    "showAllTribes": "Show all my tribes",
    "loadFailed": "Could not load skills. Please refresh the page.",
    "sharedEmptyBody": "No skills have been shared here yet. Ask a tribe member to share one.",
    "categoryEmptyBody": "No skills match the \"{{category}}\" category.",
    "allSkills": "All skills",
    "collections": "Skill collections",
    "allSources": "All sources",
    "source": "Source",
    "noMatchesBody": "Try a different search or clear your filters.",
    "clearFilters": "Clear filters"
  },
  "visibility": {
    "private": "Private",
    "privateDesc": "Only you can access",
    "orgVisible": "Org visible",
    "orgVisibleDesc": "Anyone in your org",
    "restricted": "Restricted",
    "restrictedDesc": "People you invite",
    "tribe": "Tribe",
    "tribeDesc": "All members of a tribe",
    "label": "Visibility",
    "public": "Public"
  },
  "classification": {
    "unclassified": "Unclassified",
    "confidential": "Confidential",
    "strictlyConfidential": "Strictly Confidential"
  },
  "sources": {
    "github": "GitHub",
    "internal": "Internal",
    "skillSh": "skills.sh"
  },
  "ask": {
    "title": "Ask",
    "askAboutThisSilo": "Ask about this silo… (Enter to send)",
    "askAcrossAllSilos": "Ask questions across all your knowledge silos",
    "askAboutKnowledgeflow": "Ask your knowledge base",
    "askAQuestion": "Ask any question and get answers synthesised from all accessible silos",
    "phAsk": "Ask across all silos… (Enter to send, Shift+Enter for new line)",
    "synthesised": "Answers are synthesised from your accessible knowledge silos using AI-powered search",
    "strategySearch": "{{strategy}} search"
  },
  "settings": {
    "movedToMe": "Your profile now lives in JoyIA Me. Taking you there…",
    "movedToMeNoUrl": "Your profile now lives in JoyIA Me."
  },
  "errors": {
    "failed": "Failed: {{message}}"
  },
  "forms": {
    "required": "Name *",
    "optional": "Optional",
    "selectOne": "Select one...",
    "selectMultiple": "Select multiple...",
    "enterText": "What is this silo for?",
    "enterNumber": "Enter a number...",
    "chooseFile": "Choose file...",
    "dragDropFiles": "Drag and drop files here",
    "or": "or",
    "browseFiles": "browse files",
    "description": "Description"
  },
  "pagination": {
    "previous": "Previous",
    "next": "Next",
    "of": "of",
    "page": "Page",
    "rowsPerPage": "Rows per page"
  },
  "dialogs": {
    "confirmDelete": "Confirm deletion",
    "areYouSure": "Are you sure you want to delete this item?",
    "thisCannotBeUndone": "This action cannot be undone.",
    "deleteConfirm": "Delete"
  },
  "empty": {
    "noSilos": "No silos yet",
    "noSkills": "No skills yet",
    "noResults": "No results found"
  },
  "home": {
    "searchPlaceholder": "Search across all silos...",
    "noSearchResults": "No results found",
    "totalItems": "Total Items",
    "totalMembers": "Total Members",
    "recentSilos": "Recent Silos",
    "noSilos": "No silos yet.",
    "createOne": "Create one",
    "recentItems": "Recent Knowledge Items",
    "knowledgeHealth": "Knowledge Health",
    "noItemsFromSource": "No items from this source"
  },
  "siloView": {
    "abstractSaved": "Abstract saved",
    "abstractSaveFailed": "Failed to save abstract: {{message}}",
    "siloUpdated": "Silo updated",
    "siloUpdateFailed": "Failed to update silo: {{message}}",
    "syncFailed": "Could not start sync: {{message}}",
    "generatingAbstractBackground": "Generating abstract in background…",
    "abstractDrafted": "Abstract drafted — review and save",
    "abstractGenerateFailed": "Failed to generate abstract: {{message}}",
    "editSilo": "Edit silo",
    "members": "Members",
    "config": "Config",
    "syncHistory": "Sync History",
    "treeView": "Tree View",
    "mergeSilo": "Merge Silo",
    "triggerSync": "Trigger sync now",
    "syncing": "Syncing…",
    "abstractPlaceholder": "Write a short summary of what this silo contains...",
    "editAbstract": "Edit abstract",
    "regenerateWithAI": "Regenerate with AI",
    "generatingAbstract": "Generating abstract…",
    "addSummary": "+ Add a summary for this silo...",
    "generate": "Generate",
    "generateWithAI": "Generate summary with AI",
    "cliSetupInstructions": "CLI Setup Instructions",
    "itemsInSilo": "{{count}} items in this silo",
    "cliProjectSilo": "CLI-driven project silo",
    "linkSiloToProject": "Link this silo to a project directory so your AI agents can read and write to it during development.",
    "step1": "1. Link to your project",
    "runInProjectDir": "Run this in your project directory to link this silo.",
    "step2": "2. Sync your project files",
    "syncDescription": "Ingests your project context (README, docs, config) into this silo. Idempotent — unchanged files are skipped.",
    "step3": "3. Push a single note",
    "pushDescription": "Adds one item. Both arguments are required — or pipe a file as the content:",
    "step4": "4. Use with AI agents",
    "aiAgentsDescription": "Once linked, AI coding agents (Claude Code, OpenCode, etc.) can access this silo's knowledge automatically via the MCP server.",
    "state_active": "Active",
    "state_paused": "Paused",
    "state_archived": "Archived",
    "lastSync": "Last sync: {{time}}",
    "syncOverdue": "Sync overdue",
    "nextSync": "Next sync in {{label}}",
    "source": "Source",
    "sortNewest": "Newest first",
    "sortImportance": "Highest importance",
    "sortAccessed": "Most accessed",
    "noItemsYet": "No knowledge items yet",
    "noItemsHelp": "Add items manually or configure sync sources",
    "noItemsOfType": "No {{type}} items found",
    "clearFilter": "Clear filter",
    "mergeDialog": "Merge Another Silo Into This One",
    "mergeDescription": "All items from the selected silo will be moved into {{name}}.",
    "sourceSilo": "Source Silo",
    "selectSiloMerge": "Select a silo to merge from...",
    "deleteSourceAfterMerge": "Delete source silo after merge",
    "mergeSuccess": "Merged {{count}} items successfully.{{deleted}}",
    "mergeFailed": "Merge failed: {{message}}",
    "merging": "Merging...",
    "merge": "Merge",
    "editSiloDialog": "Edit Silo",
    "tags": "Tags (comma separated)",
    "publicSilo": "Public silo",
    "publicSiloDescription": "All users in your organisation can read this silo",
    "guardrailProfiles": "Guardrail profiles",
    "guardrailDescription": "Applied to all LLM calls that process this silo's content",
    "linkToProject": "Link to a project (CLI)",
    "linkSharedSilo": "Link this as a shared silo",
    "attachSiloDescription": "Attach this silo to a project directory as {{role}}, alongside that project's own primary silo. Linked read-only — AI agents can read it, but writes still go to the project's primary silo.",
    "timelineSiloLabel": "a shared \"timeline\" (recent activity) silo",
    "knowledgeSiloLabel": "a shared \"knowledge\" silo",
    "linkLimits": "A project may link one primary silo plus up to 5 readonly ones (one knowledge, one timeline, plus additional readonly silos).",
    "healthAllClear": "Knowledge health: all clear",
    "avgImportance": "Avg importance: {{value}}",
    "staleItem": "item",
    "staleItems": "items",
    "conflict": "conflict",
    "multiConflicts": "conflicts",
    "archiveStale": "Archive {{count}} stale",
    "archiveConfirm": "Archive {{count}} items?",
    "runInProjectDirLabel": "Run in your project directory",
    "staleItemsLabel": "items",
    "staleItemsList": "{{count}} stale {{type}}",
    "archivedStale": "Archived {{count}} stale items",
    "conflicts": "{{count}} {{type}}"
  },
  "siloHealth": {
    "authExpiredTitle": "A connector can no longer sign in",
    "authExpiredBody": "Saved credentials for {{sources}} have expired — usually because the connected account's password was changed. No new content is reaching this silo until the source is reconnected.",
    "syncFailingTitle": "A connector is failing to sync",
    "syncFailingBody": "The last sync of {{sources}} failed, so no new content is reaching this silo.",
    "openSyncSettings": "Open Sync settings",
    "unindexedTitle": "This silo's content cannot be searched",
    "thinTitle": "Only part of this silo is searchable",
    "coverageBody": "{{indexed}} of {{total}} items are in the search index ({{pct}}%). Questions asked of this silo — including from any website bound to it — are answered from that part only, and no error is reported.",
    "rebuildIndex": "Rebuild the index in Sync settings"
  },
  "chart": {
    "noData": "No data to display",
    "fullscreen": "Fullscreen",
    "expandedFullscreen": "Chart expanded to fullscreen",
    "closeFullscreen": "Close fullscreen"
  },
  "apps": {
    "title": "Apps & Sources",
    "description": "Browse knowledge items by the source that created them",
    "noItems": "No knowledge items yet",
    "lastUsed": "Last used"
  },
  "skillShare": {
    "title": "Share Skill",
    "description": "Control who can see and install this skill.",
    "visibilitySet": "Visibility set to {{value}}",
    "updateFailed": "Failed to update visibility: {{message}}",
    "selectTribes": "Select tribes that can view this skill",
    "noTribes": "No tribes available",
    "selectAtLeastOne": "Select at least one tribe to save"
  },
  "skillDetail": {
    "installTracked": "Install tracked",
    "refreshedFiles": "Refreshed from source — {{n}} files",
    "refreshedNewFilesSingular": "Refreshed — {{n}} new bundled file from source",
    "refreshedNewFilesPlural": "Refreshed — {{n}} new bundled files from source",
    "refreshedFromSource": "Refreshed from source",
    "skillDeleted": "Skill deleted",
    "skillUpdated": "Skill updated",
    "share": "Share",
    "refreshing": "Refreshing…",
    "refresh": "Refresh",
    "skillNotFound": "Skill not found",
    "backToSkills": "Back to Skills",
    "public": "Public",
    "sharedWithTribe": "Shared with tribe",
    "private": "Private",
    "installs": "installs",
    "skillAdded": "Skill added!",
    "wantToTestInArena": "Want to see how it performs in the Arena?",
    "testInArena": "Test in Arena",
    "editSkill": "Edit Skill",
    "name": "Name",
    "version": "Version",
    "description": "Description",
    "content": "Content",
    "categories": "Categories",
    "extraTags": "Extra tags",
    "commaSeparated": "comma separated",
    "tagsPlaceholder": "swiftui, performance",
    "visibility": "Visibility",
    "saving": "Saving…",
    "saveChanges": "Save Changes",
    "pluginCapabilities": "Plugin Capabilities",
    "providesTools": "Provides Tools",
    "dependencies": "Dependencies",
    "readinessCheck": "Readiness Check",
    "requiredEnvironment": "Required Environment",
    "required": "Required",
    "nightWatchHooks": "Night Watch Hooks",
    "notEvaluatedYet": "Not evaluated yet",
    "runThroughArena": "Run this skill through the arena to score how well a model follows it.",
    "runArenaTest": "Run arena test",
    "arenaScore": "Arena Score",
    "testAgain": "Test again",
    "evaluations": "evaluation",
    "lastTested": "last tested",
    "hideHistory": "Hide history",
    "showAllEvaluations": "Show all {{n}} evaluations",
    "useThisSkill": "Use this skill",
    "files": "files",
    "copyCommand": "Copy command",
    "writesSKillMd": "Writes SKILL.md plus",
    "bundledFile": "bundled file",
    "copyingGivesYou": "— copying the content below gives you SKILL.md only.",
    "copySKillMd": "Copy SKILL.md",
    "tracking": "Tracking…",
    "trackInstall": "Track install",
    "preferredJoyiaCli": "Preferred — Joyia CLI",
    "setup": "Setup",
    "copy": "Copy",
    "opensInteractiveSkillBrowser": "Opens the interactive skill browser. Press",
    "toInstall": "to install.",
    "installsFromSkillsSh": "Installs from skills.sh — no Joyia account required.",
    "installFromJoyiaMarketplace": "Install from the Joyia marketplace by ID.",
    "manualInstall": "Manual install (without Joyia CLI)",
    "install": "Install",
    "cliTab": "CLI",
    "personalTab": "Personal",
    "projectTab": "Project",
    "npxSkillsInstall": "npx skills install",
    "npxSkillsAdd": "npx skills add",
    "step1AddMarketplace": "Step 1 — add marketplace",
    "step2InstallPlugin": "Step 2 — install plugin",
    "copyJSON": "Copy JSON",
    "skillContent": "Skill Content",
    "copyRaw": "Copy raw",
    "noContent": "_No content_",
    "bundledFiles": "Bundled Files",
    "alongsideSKillMd": "alongside SKILL.md",
    "collapse": "Collapse",
    "expand": "Expand",
    "deleting": "Deleting…",
    "confirmDelete": "Confirm Delete"
  },
  "sharepoint": {
    "connected": "Connected to Microsoft SharePoint",
    "signInFailed": "Sign-in failed",
    "completingSignIn": "Completing Microsoft sign-in…",
    "redirecting": "Connected — redirecting…",
    "error": "Sign-in failed",
    "backToSilos": "Back to Silos"
  },
  "auth": {
    "subtitle": "Persistent memory for your AI agents and development workflows",
    "signInWithPia": "Sign in with PIA"
  },
  "askPanel": {
    "search": "Search",
    "ask": "Ask",
    "searchFailed": "Search failed",
    "failedToGetAnswer": "Failed to get answer",
    "semanticSearchPlaceholder": "Semantic search...",
    "focusInTree": "Focus in tree",
    "askPlaceholder": "Ask a question about this knowledge base...",
    "answer": "Answer",
    "sources": "Sources",
    "resultCountSingular": "{{n}} result",
    "resultCountPlural": "{{n}} results"
  },
  "skillsArena": {
    "title": "Skills Arena",
    "description": "Test and benchmark skills — results are saved and ranked",
    "evaluateLabel": "Evaluate a Skill",
    "selectSkill": "Select a skill from the catalog or rankings below to evaluate it.",
    "testPromptLabel": "Test Prompt",
    "testPromptPlaceholder": "Enter a test prompt...",
    "evaluating": "Evaluating... (this may take 30-60s)",
    "evaluateButton": "Evaluate Skill",
    "scoreMax": "Score / 100",
    "adherenceMax": "Adherence / 10",
    "duration": "Duration",
    "criteria": "Criteria",
    "generatedOutput": "Generated Output",
    "model": "Model",
    "judge": "Judge",
    "savedToRankings": "Saved to rankings",
    "viewInLibrary": "View in Library",
    "skillCatalog": "Skill Catalog",
    "rankings": "Rankings",
    "searchCatalog": "Search catalog...",
    "noSkillsMatch": "No skills match your filters.",
    "noEvaluations": "No evaluations yet",
    "runFirstEvaluation": "Run your first Arena evaluation to start building the leaderboard.",
    "skill": "Skill",
    "avgScore": "Avg Score",
    "tests": "Tests",
    "lastRun": "Last Run",
    "librarySkill": "Library skill"
  },
  "itemView": {
    "itemSaved": "Item saved",
    "failedToSave": "Failed to save",
    "memoryArchived": "Memory archived",
    "memoryRestoredToActive": "Memory restored to active",
    "memoryPaused": "Memory paused — hidden from search",
    "failedToUpdateState": "Failed to update state",
    "itemDeleted": "Item deleted",
    "failedToDelete": "Failed to delete",
    "staleWarning": "This item may be outdated — flagged as stale by maintenance",
    "conflictDetected": "Conflict detected",
    "viewConflictingItem": "view conflicting item",
    "conflictResolved": "Conflict resolved — both items kept",
    "keepBoth": "Keep Both",
    "conflictResolvedOtherArchived": "Conflict resolved — other item archived",
    "keepThisArchiveOther": "Keep This, Archive Other",
    "thisItemArchived": "This item archived",
    "archiveThis": "Archive This",
    "tagsLabel": "Tags (comma separated)",
    "tagsPlaceholder": "tag1, tag2",
    "contentLabel": "Content",
    "relatedMemories": "Related memories",
    "deleteItemTitle": "Delete this item?",
    "deleteItemDescription": "This cannot be undone. The knowledge item and all its content will be permanently removed.",
    "deleting": "Deleting...",
    "projectLabel": "Project",
    "typeLabel": "Type",
    "statusLabel": "Status",
    "priorityLabel": "Priority",
    "assigneeLabel": "Assignee",
    "versionLabel": "Version",
    "summarised": "Summarised",
    "used": "Used",
    "timesSingular": "time",
    "timesPlural": "times",
    "importanceHigh": "high importance",
    "importanceMedium": "med importance",
    "moreOptions": "More options",
    "restoreToActive": "Restore to Active",
    "pause": "Pause",
    "archive": "Archive"
  },
  "syncHistory": {
    "heading": "Sync History",
    "backToSilo": "Back to Silo",
    "noJobs": "No sync jobs yet",
    "cancelled": "Sync cancelled — current batch will finish then stop",
    "finalising": "Finalising…",
    "sourcePagesTip": "Source pages scanned — not the same as items added to the silo",
    "src": "src",
    "itemsCreatedTip": "New items added to silo",
    "itemsUpdatedTip": "Existing items updated",
    "itemsSkippedTip": "Unchanged items skipped",
    "itemsDeletedTip": "Items removed from silo",
    "stopSync": "Stop sync",
    "jobId": "Job ID",
    "parentSync": "Parent sync",
    "triggeredBy": "Triggered by",
    "duration": "Duration",
    "since": "Since",
    "sinceLower": "since",
    "items": "Items",
    "new": "new",
    "updated": "updated",
    "unchanged": "unchanged",
    "deleted": "deleted",
    "refused": "Refused",
    "refusedTitleSingular": "{{n}} file not indexed — sensitivity label forbids it",
    "refusedTitlePlural": "{{n}} files not indexed — sensitivity label forbids it",
    "refusedCountSingular": "{{n}} file not indexed",
    "refusedCountPlural": "{{n}} files not indexed",
    "errorCountSingular": "{{n}} error",
    "errorCountPlural": "{{n}} errors",
    "retryFailedPagesSingular": "Retry {{n}} failed page",
    "retryFailedPagesPlural": "Retry {{n}} failed pages",
    "labelled": "labelled",
    "retrying": "Retrying…",
    "retry": "Retry",
    "finalisingDetail": "Finalising — verifying no more pages remain, then closing the job…",
    "scanningSource": "Scanning source…",
    "sourcePages": "source pages",
    "sourcePageNote": "Source pages scanned ≠ items added. Item counts (+new ~updated =skipped) accumulate as each batch completes.",
    "processing": "Processing…",
    "processingProgress": "Processing… {{processed}} / {{total}}",
    "starting": "Starting… waiting for first batch",
    "waitingForWorker": "Waiting for worker to pick up the job…",
    "stoppedBy": "Stopped by {{user}} — pages already ingested are kept",
    "user": "user"
  },
  "syncConfig": {
    "dangerZone": "Danger Zone",
    "resetStoreTitle": "Reset store & restart",
    "resetStoreDesc": "Deletes all ingested items and clears sync cursors. Source configuration is preserved. The next sync will be a full re-ingest from scratch.",
    "resetRestartBtn": "Reset & Restart",
    "areYouSure": "Are you sure?",
    "resetting": "Resetting…",
    "yesReset": "Yes, reset",
    "rebuildIndexTitle": "Rebuild search index",
    "rebuildIndexDesc": "Rebuilds the semantic search tree from the items already in this silo. Nothing is deleted and no content is lost. Use this if search returns nothing, or if asking this silo a question answers that it \"is not searchable yet\" while no sync is running — that state does not clear on its own. Also worth running after a large batch import.",
    "indexing": "Indexing…",
    "queuing": "Queuing…",
    "rebuildIndexBtn": "Rebuild Index",
    "tokenHelp": {
      "confluence": "Create an Atlassian API token",
      "jira": "Create an Atlassian API token",
      "openwebui": "Create an API key in chat.joyia.p7s1.io (Settings → Account)",
      "gitlab": "Create a GitLab personal access token",
      "github": "Create a GitHub personal access token",
      "slack": "Create a Slack app + bot token",
      "teams": "Azure Portal → App registrations → Certificates & secrets",
      "sharepoint": "Azure Portal → App registrations → Certificates & secrets",
      "gdrive": "Google Cloud Console → Service Accounts → Keys"
    },
    "heading": "Sync Configuration",
    "syncHistory": "Sync History",
    "addSource": "Add Source",
    "addIngestSource": "Add ingest source",
    "docAndTimelineConnectors": "Document and timeline connectors",
    "phBaseUrl": "Base URL",
    "phApiToken": "API Token",
    "phEmail": "Email",
    "phGitlabUrl": "GitLab Base URL (e.g. https://gitlab.com)",
    "phPersonalAccessToken": "Personal Access Token",
    "phProjectPaths": "Project keys / paths (comma-separated, e.g. mygroup/myrepo)",
    "phEnvironments": "Environments (optional, comma-separated, e.g. production,staging)",
    "phDatadogApiKey": "Datadog API Key",
    "createDatadogApiKey": "Create a Datadog API key ↗",
    "phDatadogAppKey": "Datadog Application Key",
    "createDatadogAppKey": "Create a Datadog application key ↗",
    "phDatadogSiteDefault": "Site (default: datadoghq.eu)",
    "phServices": "Services (optional, comma-separated)",
    "phFilterTags": "Filter tags (optional, e.g. env:production)",
    "phGithubPatPlain": "GitHub Personal Access Token",
    "phRepositories": "Repositories (comma-separated, e.g. owner/repo, owner/repo2)",
    "phPagerdutyKey": "PagerDuty REST API Key",
    "phServiceIds": "Service IDs (optional, comma-separated)",
    "phTeamIdsOptional": "Team IDs (optional, comma-separated)",
    "phBotTokenXoxb": "Bot User OAuth Token (xoxb-...)",
    "phChannelIdsLong": "Channel IDs (comma-separated, e.g. C0123456789, C9876543210)",
    "phWorkspaceLong": "Workspace name (optional, e.g. Acme Engineering)",
    "phTenantId": "Azure AD Tenant ID",
    "phClientId": "App Registration Client ID",
    "phClientSecret": "Client Secret",
    "phTeamIds": "Team IDs (comma-separated)",
    "phSiteId": "Site ID (or leave blank and use Site URL below)",
    "phSiteUrl": "Site URL (e.g. contoso.sharepoint.com:/sites/Engineering)",
    "resourceType": "Resource type:",
    "documentLibrary": "Document library",
    "sharepointList": "SharePoint list",
    "phListId": "List ID",
    "phDriveIdLong": "Drive ID (optional — defaults to the site's document library)",
    "phFolderPathLong": "Folder path (optional — subfolder to scope the sync to)",
    "phServiceAccountEmail": "Service Account Email",
    "phPrivateKeyLong": "Private Key (paste the full PEM key from the service account JSON)",
    "phFolderIdsLong": "Folder IDs (comma-separated — share each folder with the service account email)",
    "entireSpaces": "Entire spaces",
    "phSpaceKeysLong": "Space keys (comma-separated, e.g. ENG, DOCS)",
    "importsEveryPage": "Imports every page in each listed space.",
    "pageTrees": "Page trees",
    "phPageIds": "Page IDs (comma-separated)",
    "phProjectKeysLong": "Project keys (comma-separated, e.g. ENG, OPS)",
    "phIssueTypesLong": "Issue types (optional, comma-separated, e.g. Bug, Story)",
    "phJqlLong": "Custom JQL (optional — overrides project keys)",
    "scheduleAuto": "Schedule automatic sync",
    "every6h": "Every 6h",
    "every12h": "Every 12h",
    "every24h": "Every 24h",
    "every48h": "Every 48h",
    "cancel": "Cancel",
    "titleStopSync": "Stop sync (current batch finishes then stops)",
    "titlePreviewPage": "Preview most recently modified page",
    "titleDiscoverCount": "Discover real page count by paginating Confluence",
    "extractingWithAi": "Extracting and summarising page with AI…",
    "openInConfluence": "Open in Confluence ↗",
    "looksGoodStartSync": "Looks good — start full sync",
    "close": "Close",
    "tryAnotherPage": "Try another page",
    "phSpaceKeysShort": "Space keys (comma-separated)",
    "phProjectKeysShort": "Project keys (comma-separated)",
    "phIssueTypesShort": "Issue types (optional)",
    "phJqlShort": "Custom JQL (optional)",
    "phAccessTokenKeep": "Access Token (leave blank to keep existing)",
    "phApiKeyKeep": "API Key (leave blank to keep existing)",
    "phAppKeyKeep": "Application Key (leave blank to keep existing)",
    "phDatadogSite": "Site (e.g. datadoghq.eu)",
    "phGithubPat": "GitHub Personal Access Token (leave blank to keep existing)",
    "phRestApiKey": "REST API Key (leave blank to keep existing)",
    "phBotToken": "Bot User OAuth Token (leave blank to keep existing)",
    "phChannelIds": "Channel IDs (comma-separated)",
    "phWorkspaceShort": "Workspace name (optional)",
    "phTenantIdKeep": "Azure AD Tenant ID (leave blank to keep existing)",
    "phClientIdKeep": "App Registration Client ID (leave blank to keep existing)",
    "phClientSecretKeep": "Client Secret (leave blank to keep existing)",
    "noSitesFound": "No sites found for this connection.",
    "phDriveIdShort": "Drive ID (optional)",
    "phFolderPathShort": "Folder path (optional)",
    "browseFolders": "Browse folders",
    "useThisFolder": "Use this folder",
    "loading": "Loading…",
    "emptyFolder": "Empty folder.",
    "phServiceAccountEmailKeep": "Service Account Email (leave blank to keep existing)",
    "phPrivateKeyKeep": "Private Key (leave blank to keep existing)",
    "phFolderIdsShort": "Folder IDs (comma-separated)",
    "enableWebhook": "Enable webhook ingestion",
    "noIngestSources": "No ingest sources configured yet",
    "addOpenwebuiOutputBtn": "Add OpenWebUI Output",
    "addOpenwebuiOutput": "Add OpenWebUI Output",
    "phOpenwebuiUrl": "Base URL (e.g. https://chat.joyia.p7s1.io)",
    "phApiKey": "API Key",
    "phKnowledgeBaseIds": "Knowledge Base IDs (one per line or comma-separated)",
    "addOutput": "Add Output",
    "titleTriggerOutput": "Trigger output sync now",
    "noOutputs": "No outputs configured yet",
    "deleteSilo": "Delete this silo",
    "deleteSiloBtn": "Delete Silo",
    "thisIsPermanent": "This is permanent!",
    "deleting": "Deleting…",
    "testing": "Testing...",
    "testConnection": "Test Connection",
    "pagerDutyPath": "In your PagerDuty account: {{path}}",
    "recommendedOwnAccount": "Recommended: connect with your own Microsoft account (no Azure admin needed)",
    "orAppOnly": "Or configure app-only auth manually (requires an Azure AD admin to grant Sites.Selected access):",
    "copyListId": "Required. Copy the list ID from SharePoint or Microsoft Graph Explorer.",
    "askToVerify": "Ask a question about this page to verify the AI understood it:",
    "fetchingConfluence": "Fetching page from Confluence and running AI summarisation…",
    "pickSiteFirst": "Pick a site or enter a Site ID/URL above first.",
    "deleteSiloWarning": "Permanently deletes the silo, all items, sync configuration, and knowledge graph nodes. This cannot be undone.",
    "raptorRebuildQueued": "RAPTOR index rebuild queued — check Sync History for progress",
    "rebuildFailed": "Rebuild failed: {{error}}",
    "syncCancelled": "Sync cancelled — current batch will finish then stop",
    "cancelFailed": "Cancel failed: {{error}}",
    "resetComplete": "Reset complete — {{deletedItems}} items deleted, {{sourcesReset}} source(s) cleared. Trigger a full sync to re-ingest.",
    "resetFailed": "Reset failed: {{error}}",
    "syncFailed": "Sync failed: {{error}}",
    "outputSyncQueued": "Output sync queued",
    "outputSyncFailed": "Output sync failed: {{error}}",
    "sourceAdded": "Source added",
    "failedToAddSource": "Failed to add source: {{error}}",
    "sourceRemoved": "Source removed",
    "failedToRemoveSource": "Failed to remove source: {{error}}",
    "sourceUpdated": "Source updated",
    "failedToUpdateSource": "Failed to update source: {{error}}",
    "enterBaseUrlAndApiKeyFirst": "Please enter Base URL and API Key first.",
    "connectedFoundKbsWithNames": "Connected! Found {{count}} knowledge base(s): {{names}}",
    "connectedFoundKbs": "Connected! Found {{count}} knowledge base(s).",
    "connectionFailed": "Connection failed: {{error}}",
    "outputAdded": "Output added",
    "failedToAddOutput": "Failed to add output: {{error}}",
    "outputRemoved": "Output removed",
    "failedToRemoveOutput": "Failed to remove output: {{error}}",
    "discoverFailed": "Discover failed: {{error}}",
    "previewFailed": "Preview failed: {{error}}",
    "askFailed": "Ask failed: {{error}}",
    "descSpaces": "spaces: {{keys}}",
    "descProjects": "projects: {{keys}}",
    "descJql": "JQL: {{jql}}…",
    "descServices": "services: {{services}}",
    "descRepos": "repos: {{repos}}",
    "descTeams": "teams: {{teams}}",
    "descChannels": "channels: {{channels}}",
    "descSyncedViaCli": "Synced via joyia CLI (joyia memory sync)",
    "descList": "list: {{listId}}",
    "descListNoId": "list (no List ID set)",
    "descFolder": "folder: {{folderPath}}",
    "descNoSiteConfigured": "No site configured",
    "descFolders": "folders: {{folders}}",
    "descNoFoldersConfigured": "No folders configured",
    "descNoUrlConfigured": "No URL configured",
    "disableScheduledSync": "Disable scheduled sync",
    "enableScheduledSync": "Enable scheduled sync",
    "schedule": "schedule",
    "cancelEdit": "Cancel edit",
    "editSource": "Edit source",
    "incrementalSyncTitle": "Incremental sync (changes only)",
    "fullSyncTitle": "Full sync",
    "syncAlreadyRunning": "Sync already running",
    "forceFullResync": "Force full re-sync (all pages)",
    "rawExcerptAiUnavailable": "Raw excerpt (AI unavailable)",
    "aiSummary": "AI Summary",
    "phAskPageQuestion": "e.g. What is the main topic of this page?",
    "webhookUrlCopied": "Webhook URL copied",
    "copy": "Copy",
    "yesDelete": "Yes, delete",
    "totalPages": "Total: {{total}} pages"
  },
  "connector": {
    "confluence": "Confluence",
    "confluenceDesc": "Pages & spaces",
    "jira": "Jira",
    "jiraDesc": "Issues & projects",
    "openwebui": "OpenWebUI",
    "openwebuiDesc": "Knowledge base",
    "gitlab": "GitLab",
    "gitlabDesc": "Pipelines, MRs & deploys",
    "datadog": "Datadog",
    "datadogDesc": "Monitors & events",
    "github": "GitHub",
    "githubDesc": "Actions, PRs & releases",
    "pagerduty": "PagerDuty",
    "pagerdutyDesc": "Incidents & on-call",
    "slack": "Slack",
    "slackDesc": "Channel digests & discussions",
    "teams": "MS Teams",
    "teamsDesc": "Channel activity",
    "local": "Local / CLI",
    "localDesc": "Project files via joyia CLI",
    "sharepoint": "SharePoint",
    "sharepointDesc": "Document libraries",
    "gdrive": "Google Drive",
    "gdriveDesc": "Docs, Sheets & Slides"
  },
  "newSkill": {
    "skillCreated": "Skill “{{name}}” created",
    "skillImported": "Imported “{{name}}”",
    "noSkillFilesFound": "No .md skill files found in this repository",
    "couldNotQueryGitHub": "Could not query GitHub",
    "couldNotFetchSkill": "Could not fetch skill from GitHub",
    "invalidRef": "Invalid ref — use owner/repo/path/to/file.md",
    "couldNotFetchFile": "Could not fetch file from GitHub",
    "pageTitle": "New Skill",
    "createTab": "Create",
    "importTab": "Import from GitHub",
    "nameLabel": "Name *",
    "namePlaceholder": "code-review",
    "versionLabel": "Version",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Short description of what this skill does",
    "contentLabel": "Content *",
    "categoriesLabel": "Categories",
    "extraTagsLabel": "Extra tags",
    "optional": "(optional)",
    "visibilityLabel": "Visibility",
    "pasteAnyOf": "Paste any of these:",
    "pasteUrlPlaceholder": "Paste a GitHub URL or owner/repo/path…",
    "searchSpecificDirectory": "Search in a specific directory",
    "customSearchPlaceholder": "e.g. agents/ or .claude/skills",
    "readyToImport": "Ready to import",
    "categoriesLabelImport": "Categories",
    "optionalAddsToImportedTags": "(optional, adds to imported tags)",
    "visibilityAfterImport": "Visibility after import",
    "importing": "Importing…",
    "importButton": "Import Skill",
    "contentPlaceholder": "# Skill Content\n\nDescribe the skill instructions, prompts, or configuration here…",
    "creating": "Creating…",
    "createButton": "Create Skill",
    "discovering": "Discovering…",
    "loading": "Loading…",
    "discoverButton": "Discover",
    "previewButton": "Preview",
    "searchButton": "Search",
    "notFoundSpecifyPath": "Not found? Specify path →",
    "importButtonLabel": "Import Skill",
    "repoUrl": "Repo URL",
    "directFileUrl": "Direct file URL",
    "foundFilesSingular": "Found {{n}} skill file — click to preview",
    "foundFilesPlural": "Found {{n}} skill files — click to preview"
  },
  "siloTimeline": {
    "mapNotGenerated": "Platform Intelligence Map not yet generated",
    "triggerSyncToBuild": "Trigger a sync to build it.",
    "builtFromSnapshots": "Built from your daily snapshots — push some with `joyia memory sync git-log`, or attach a server-side integration.",
    "platformMap": "Platform Intelligence Map",
    "historicalRecord": "Historical Record",
    "noSnapshotsYet": "No daily snapshots yet. Trigger a sync to start ingesting.",
    "noSnapshotsPush": "No daily snapshots yet. Push them from your project with `joyia memory sync git-log`.",
    "seeded": "Seeded {{count}} timeline items",
    "seedTestData": "Seed test data",
    "dailySnapshots": "Daily Snapshots",
    "windowDesc": "(30-day rolling window, older data compacted into Historical Record)",
    "timelineExplorer": "Timeline Explorer",
    "updatedAgo": "Updated {{time}}",
    "noContentYet": "No content yet.",
    "daysAgoSingular": "{{n}} day ago",
    "daysAgoPlural": "{{n}} days ago"
  },
  "siloTree": {
    "syncing": "Syncing…",
    "treeStats": "Tree Stats",
    "totalNodes": "Total Nodes",
    "layers": "Layers",
    "leafNodes": "Leaf Nodes",
    "summaries": "Summaries",
    "legend": "Legend",
    "leafChunk": "Leaf chunk",
    "treeExplorer": "Tree Explorer",
    "loadingTree": "Loading tree...",
    "failedToLoad": "Failed to load tree",
    "retry": "Retry",
    "noTreeYet": "No RAPTOR tree built yet",
    "triggerSync": "Trigger a sync to build the semantic index.",
    "goToSilo": "Go to Silo",
    "summarisedFrom_one": "Summarised from {{count}} node",
    "summarisedFrom_other": "Summarised from {{count}} nodes",
    "childCountSingular": "{{n}} child",
    "childCountPlural": "{{n}} children",
    "nodesAndLayers": "{{nodes}} nodes · {{layers}} layers"
  },
  "createItem": {
    "addItem": "Add Knowledge Item",
    "title": "Title *",
    "phTitle": "Item title",
    "content": "Content",
    "phContent": "Markdown supported...",
    "knowledgeType": "Knowledge Type",
    "typeAuto": "Auto-detect",
    "typeFactual": "Factual — reference docs, stable facts",
    "typeProcedural": "Procedural — runbooks, how-to guides",
    "typeTemporal": "Temporal — time-bound events, snapshots",
    "typeRelational": "Relational — dependencies, architecture",
    "typeContextual": "Contextual — current state, incidents",
    "typeSocial": "Social — team structure, ownership",
    "typePolicy": "Policy — compliance, SLAs, governance",
    "typeMeta": "Meta — summaries, indexes",
    "tags": "Tags (comma separated)",
    "suggestTags": "AI-suggest tags from title and content"
  },
  "createSilo": {
    "startingLayout": "Starting layout",
    "change": "Change",
    "tags": "Tags (comma separated)",
    "publicSilo": "Public silo",
    "publicSiloDesc": "All users in your organisation can read this silo",
    "guardrailProfiles": "Guardrail profiles",
    "guardrailDesc": "Applied to all LLM calls that process this silo's content",
    "cancel": "Cancel",
    "creating": "Creating...",
    "create": "Create Silo",
    "createFailed": "Failed to create silo: {{message}}"
  },
  "errorBoundary": {
    "somethingWrong": "Something went wrong",
    "unexpected": "An unexpected error occurred",
    "tryAgain": "Try again",
    "goHome": "Go home"
  },
  "siloShare": {
    "private": "Private",
    "privateDesc": "Only you can access",
    "restricted": "Restricted",
    "restrictedDesc": "People you invite",
    "tribe": "Tribe",
    "tribeDesc": "All members of a tribe",
    "orgVisible": "Org visible",
    "orgVisibleDesc": "Anyone in your org",
    "shareSilo": "Share Silo",
    "controlAccess": "Control who can access this knowledge silo.",
    "visibility": "Visibility",
    "selectTribes": "Select tribes that can view this silo",
    "noTribes": "No tribes available",
    "selectAtLeastOne": "Select at least one tribe to save",
    "pendingRequests": "Pending requests",
    "approve": "Approve",
    "deny": "Deny",
    "peopleWithAccess": "People with access",
    "emailAddress": "Email address",
    "roleViewer": "Viewer",
    "roleEditor": "Editor",
    "invite": "Invite",
    "youOwner": "You (owner)",
    "owner": "Owner",
    "removeMember": "Remove member",
    "noMembers": "No additional members yet. Invite someone above."
  },
  "globalChat": {
    "suggestConnectSource": "How do I connect a source?",
    "suggestSiloVsSkill": "What's the difference between a silo and a skill?",
    "closeChat": "Close chat",
    "askAi": "Ask AI",
    "clearConversation": "Clear conversation",
    "askKnowledgeBase": "Ask your knowledge base",
    "liveAccess": "Live access:",
    "askAboutKf": "Ask about Knowledgeflow",
    "phAskKf": "Ask about Knowledgeflow… (Enter to send)",
    "verifyBeforeActing": "Answers come from the docs — always verify before acting.",
    "yourKnowledge": "Your knowledge",
    "help": "Help",
    "thisSilo": "This silo",
    "allSilos": "All silos",
    "searchingWithinThisSilo": "Searching within this silo",
    "searchingAcrossAllSilos": "Searching across all silos",
    "suggestMonitorsAlerting": "What monitors are alerting?",
    "suggestRecentEvents": "Show recent events",
    "suggestOpenMergeRequests": "Show open merge requests",
    "suggestRecentPipelineStatus": "Recent pipeline status",
    "suggestIssuesInProgress": "What issues are in progress?",
    "suggestTopicsCovered": "What topics are covered?",
    "suggestFindRecentItems": "Find recent items",
    "suggestSummarizeSilo": "Summarize this silo",
    "phAskAllSilos": "Ask across all silos… (Enter to send)",
    "contentPolicies": "Content policies",
    "contentPoliciesActive": "Content policies (active)",
    "answerFromDocs": "I answer from the Knowledgeflow documentation."
  },
  "knowledgeChat": {
    "searchResultSingular": "{{n}} result for “{{query}}”",
    "searchResultPlural": "{{n}} results for “{{query}}”"
  },
  "inlineTable": {
    "rowCountSingular": "{{n}} row",
    "rowCountPlural": "{{n}} rows",
    "showMoreSingular": "Show {{n}} more row",
    "showMorePlural": "Show {{n}} more rows",
    "showLess": "Show less"
  },
  "bundledFiles": {
    "heading": "Bundled files",
    "phContents": "File contents…",
    "skippedSingular": "{{n}} file skipped — only text files can be published.",
    "skippedPlural": "{{n}} files skipped — only text files can be published.",
    "read": "Read {{file}}",
    "readAndMore": "Read {{file}} and {{n}} more"
  },
  "skillDropzone": {
    "plusFileSingular": "+ {{n}} file",
    "plusFilePlural": "+ {{n}} files"
  },
  "skillCard": {
    "viewSkill": "View Skill",
    "bundlesSingular": "Bundles {{n}} file alongside SKILL.md",
    "bundlesPlural": "Bundles {{n}} files alongside SKILL.md",
    "fileCountSingular": "{{n}} file",
    "fileCountPlural": "{{n}} files"
  },
  "carousel": {
    "prevSlide": "Previous slide",
    "nextSlide": "Next slide"
  },
  "agentElement": {
    "maxTurns": "Max turns"
  },
  "collab": {
    "settings": "Collab Settings",
    "approvalMode": "Approval Mode",
    "maxTurnsPerPersona": "Max Turns per Persona",
    "resetCounter": "Reset turn counter",
    "reset": "Reset"
  },
  "connectionStatus": {
    "offline": "No connection. Figures cannot be refreshed until you are back online.",
    "reload": "Reload"
  },
  "helpAnswer": {
    "sources": "Sources"
  },
  "helpWidget": {
    "clearAria": "Clear conversation",
    "clear": "Clear conversation",
    "closeAria": "Close help",
    "reading": "Reading the docs…",
    "verifyNote": "Answers come from the docs — always verify before acting.",
    "productHelp": "{{product}} help",
    "productHelpDrag": "{{product}} help — drag to move",
    "answersFromDocs": "Answers from the {{product}} docs",
    "askAbout": "Ask about {{product}}",
    "askAboutDetail": "I answer from the {{product}} documentation and can point you to the right place.",
    "askAboutPlaceholder": "Ask about {{product}}…",
    "notAvailableYet": "Help is not available here yet.",
    "somethingWentWrong": "Something went wrong (HTTP {{status}}).",
    "requestFailed": "The request failed.",
    "couldNotRunAction": "Could not {{action}}."
  },
  "citation": {
    "prevAria": "Previous",
    "nextAria": "Next"
  },
  "installPrompt": {
    "notNowAria": "Not now",
    "iosPath": "Share → Add to Home Screen",
    "showMeHow": "Show me how",
    "install": "Install"
  },
  "messageEditor": {
    "cancel": "Cancel"
  },
  "message": {
    "copy": "Copy message",
    "regenerate": "Regenerate response",
    "edit": "Edit message",
    "goodResponse": "Good response",
    "poorResponse": "Poor response"
  },
  "plan": {
    "toggle": "Toggle plan"
  },
  "promptInput": {
    "removeAttachment": "Remove attachment"
  },
  "reasoning": {
    "thinking": "Thinking...",
    "thoughtFor": "Thought for a few seconds",
    "thoughtForSeconds_one": "Thought for {{count}} second",
    "thoughtForSeconds_other": "Thought for {{count}} seconds"
  },
  "tool": {
    "streaming": "Streaming",
    "running": "Running",
    "approvalRequired": "Approval Required",
    "approved": "Approved",
    "completed": "Completed",
    "denied": "Denied",
    "error": "Error",
    "pending": "Pending"
  }
}
